<script lang="ts">
  import { PageLoadingSpinner } from "$lib/ui/loading-spinner";
  import PageAccessDenied from "../PageAccessDenied.svelte";
  import { authStateStore } from "$lib/stores/user";
  import { selectedOrgStore } from "$lib/stores/orgs";
  import { orgSecuritySensitiveDataStore } from "$lib/stores/orgSensitiveData";
  import SectionTitle from "$lib/components/shared/SectionTitle.svelte";
  import { params } from "svelte-spa-router";
  import Gears from "$assets/images/gears.png";
  import GlobeAlt from "$assets/icons/globe-alt.svelte";
  import SensitiveDataContainer from "$lib/components/security/SensitiveDataContainer.svelte";

  let isLoadingPage = $state(true);
  let isEmptyFindings = $state<boolean | undefined>(undefined);
  let canView = $derived.by(() => {
    const userEmail = $authStateStore.userInfo?.email?.toLowerCase();
    return (
      !!userEmail &&
      !!$selectedOrgStore?.members &&
      !!$selectedOrgStore?.members.find(
        (o) => o.email?.toLowerCase() === userEmail && o.claims.includes("org:security_findings"),
      )
    );
  });

  $effect(() => {
    if ($orgSecuritySensitiveDataStore) {
      isEmptyFindings = $orgSecuritySensitiveDataStore.sensitiveContentCount?.length == 0;
      isLoadingPage = false;
    }
  });
</script>

{#if isLoadingPage}
  <PageLoadingSpinner timeout={10_000} message={"Loading..."} />
{:else if canView}
  <div class="grow px-6 lg:px-10 py-5 sm:py-8 lg:py-10 text-offblack">
    <SectionTitle>Sensitive Data Detection</SectionTitle>
    <div class="flex flex-col gap-2">
      <div class="rounded-lg bg-white shadow">
        <div class="px-4 py-4 sm:px-6 flex gap-2 items-center">
          <span class="text-blue-500"><GlobeAlt /></span>
          <h2 class="font-bold text-lg">Detected Sensitive Data</h2>
        </div>
        <div class="px-4 py-2 sm:px-6 flex flex-col gap-2">
          <SensitiveDataContainer />
        </div>
      </div>
    </div>
  </div>
{:else}
  <PageAccessDenied />
{/if}
